import { Trash } from 'lucide-react'
import { ButtonIcon, DefaultTable, Input } from 'twyne-new.ui'

import { DefaultDragFormatter, DndSortableList, useSortableDndListItem } from '@/components/SortableDnd'

const SortableRow = ({ children, row, className }) => {
  const dnd = useSortableDndListItem(row.id)
  return <tr ref={dnd.setNodeRef} style={dnd.style} className={className}>
    {children}
  </tr>
}

const SortableList = ({ items, onChange, onDelete, onSortEnd }) => {
  const data = items.map((item, i) => ({ ...item, id: i }))

  const columns = [
    {
      dataField: '',
      text: '',
      className: 'w-8',
      formatter: (_, row) => <DefaultDragFormatter row={row} />,
    },
    {
      dataField: 'label',
      text: 'Label',
      formatter: (_, row, rowIndex) => <Input
        value={row.label}
        placeholder="Title"
        onChange={e => onChange(rowIndex, 'label', e.target.value)}
      />,
    },
    {
      dataField: 'url',
      text: 'URL',
      formatter: (_, row, rowIndex) => <Input
        value={row.url}
        placeholder="URL"
        onChange={e => onChange(rowIndex, 'url', e.target.value)}
      />,
    },
    {
      dataField: '',
      text: '',
      className: 'w-8',
      formatter: (_, _row, rowIndex) => <ButtonIcon
        content="Delete"
        onClick={() => onDelete(rowIndex)}
      >
        <Trash size={16} />
      </ButtonIcon>,
    },
  ]

  return <DndSortableList items={data} onSortEnd={onSortEnd}>
    <DefaultTable
      columns={columns}
      data={data}
      rowWrapper={SortableRow}
    />
  </DndSortableList>
}

export default SortableList
